import axios from "axios";
import _ from "underscore";


const getDefaultState = () => {
  return {
    functional_areas: [],
    functional_areas_for_user: [],
    functional_areas_with_shifts: [],
    rosters: [],
    labor_agreements: [],
    cost_centers: [],
    devices: [],
    excuses: [],
    roles: [],
    shift_assignments: [],
    shift_assignments_filters: {
      functional_area_id: null,
      date_from: null,
      date_to: null
    },
    groups: {},
    groups_filters: {
      functional_area_id: null,
      date_from: null,
      date_to: null
    },
    holidays: {},
    holidays_filters: {
      date_from: null,
      date_to: null
    },
  }
}

const state = getDefaultState();

const getters = {
  functional_areas: state => state.functional_areas,
  functional_areas_for_user: state => state.functional_areas_for_user,
  functional_areas_with_shifts: state => state.functional_areas_with_shifts,
  labor_agreements: state => state.labor_agreements,
  rosters: state => state.rosters,
  cost_centers: (state) => state.cost_centers,
  devices: state => state.devices,
  devices_key_value: state => {
    let elems = {};
    for (let i = 0; i < state.devices.length; i++) {
      elems[state.devices[i].value] = state.devices[i].label;
    }
    // state.devices.each().each(({value, label}) => { elems[value] = label});
    return elems;
  },
  excuses: state => state.excuses,
  roles: state => state.roles,
  shift_assignments: state => state.shift_assignments,
  groups: state => state.groups,
  holidays: state => state.holidays,
};

const actions = {
  resetState ({ commit }) {
    commit('resetState')
  },
  async fetchFunctionalAreas({ state, commit }) {
    if (!state.functional_areas.length) {
      const response = await axios.get("/api/functionalareas/options");
      commit(
        "setFunctionalAreas",
        _.sortBy(_.map(response.data, (description, id) => ({
          label: description,
          value: id
        })), 'label')
      );
    }
  },
  async fetchFunctionalAreasForUser({ state, commit }) {
    if (!state.functional_areas.length) {
      const response = await axios.get("/api/functionalareas/optionsByUser");
      commit(
        "setFunctionalAreasForUser",
        _.sortBy(_.map(response.data, (description, id) => ({
          label: description,
          value: id
        })), 'label')
      );
    }
  },
  async fetchFunctionalAreasWithShifts({ state, commit }) {
    if (!state.functional_areas_with_shifts.length) {
      const response = await axios.get("/api/functionalareas/withShifts");
      let functional_areas = {};
      response.data.forEach(
        element => (functional_areas[element.id] = element)
      );
      commit("setFunctionalAreasWithShifts", functional_areas);
    }
  },
  async fetchLaborAgreements({ state, commit }) {
    if (!state.labor_agreements.length) {
      const response = await axios.get("/api/laboragreements/options");
      commit(
        "setLaborAgreements",
        _.sortBy(_.map(response.data, (description, id) => ({
          label: description,
          value: id
        })), 'label')
      );
    }
  },
  async fetchRosters({ state, commit }) {
    if (!state.rosters.length) {
      const response = await axios.get("/api/rosters/options");
      commit(
        "setRosters",
        _.sortBy(_.map(response.data, (description, id) => ({
          label: description,
          value: id
        })), 'label')
      );
    }
  },
  async fetchCostCenters({ state, commit }) {
      if (!state.cost_centers.length){
          const response = await axios.get('/api/costcenters/options');
          commit('setCostCenters', _.map(response.data, (description, id) => ({label: description, value: id})));
      }
  },
  async fetchDevices({ state, commit }) {
    if (!state.devices.length) {
      const response = await axios.get("/api/devices/options");
      commit(
        "setDevices",
        _.sortBy(_.map(response.data, (description, id) => ({
          label: description,
          value: id
        })), 'label')
      );
    }
  },
  async fetchExcuses({ state, commit }) {
    if (!state.excuses.length) {
      const response = await axios.get("/api/excuses/options");
      commit(
        "setExcuses",
        _.sortBy(_.map(response.data, (item, id) => ({
          label: typeof item === 'object' ? item.description : item,
          value: typeof item === 'object' ? item.id : id,
          justified: typeof item === 'object' ? (item.justified == 1 || item.justified === true) : true,
          paid: typeof item === 'object' ? (item.paid == 1 || item.paid === true) : true,
        })), 'label')
      );
    }
  },
  async fetchRoles({ state, commit }) {
    if (!state.roles.length) {
      const response = await axios.get("/api/roles/options");
      commit(
        "setRoles",
        _.sortBy(_.map(response.data, (description, id) => ({
          label: description,
          value: description
        })), 'label')
      );
    }
  },
  async fetchShiftAssignments({ state, commit }, filters, force = false) {
    commit("setShiftAssignments", []);
    if (!force && (filters.functional_area_id == null || filters.date_from == null || filters.date_to == null)) {
      return;
    }
    if (force || state.shift_assignments_filters != filters) {
      commit("setShiftAssignmentsFilters", filters);
      const response = await axios.get('/api/employees/shiftassignment', {
        params: {
          functional_area_id: state.shift_assignments_filters.functional_area_id,
          date_from: state.shift_assignments_filters.date_from,
          date_to: state.shift_assignments_filters.date_to
        }
      });
      commit("setShiftAssignments", response.data.data);
    }
  },
  async fetchGroups({ state, commit }, filters) {
    commit("setGroups", {});
    // console.log('fetchGroups', filters);
    if (filters.functional_area_id == null || filters.date_from == null || filters.date_to == null) {
      // console.log('fetchGroups - empty filters');
      return;
    }
    // console.log('fetchGroups - ok');
    // if (state.groups_filters != filters) {
      commit("setGroupsFilters", filters);
      const response = await axios.get('/api/functionalareas/'+state.groups_filters.functional_area_id+'/groups', {
        params: {
          date_from: state.groups_filters.date_from,
          date_to: state.groups_filters.date_to
        }
      });
      // console.log('fetchGroups - data', response.data);
      // response.data.push({id: 0, name: 'Default'});
      let groups = {0: {id: 0, name: 'Default'}};
      response.data.forEach((group) => {
        groups[group.id] = group;
      });
      commit("setGroups", groups);
    // }
  },
  async fetchHolidays({ state, commit }, filters) {
    // console.log('fetchHolidays', filters);
    if (filters.date_from == null || filters.date_to == null) {
      // console.log('fetchGroups - empty filters');
      return;
    }
    // console.log('fetchGroups - ok');
    if (state.groups_filters != filters) {
      commit("setHolidays", {});
      commit("setHolidaysFilters", filters);
      // console.log('fetchHolidays', 'fetch');
      const response = await axios.get('/api/holidays/keybydate', {
        params: {
          date_from: state.holidays_filters.date_from,
          date_to: state.holidays_filters.date_to
        }
      });
      // console.log('fetchGroups - data', response.data);
      // response.data.push({id: 0, name: 'Default'});
      // response.data.forEach((group) => {
      //   groups[group.id] = group;
      // });
      commit("setHolidays", response.data);
    }
  },
  // async addTodo({ commit }, title) {
  //   const response = await axios.post(
  //     "https://jsonplaceholder.typicode.com/todos",
  //     { title, completed: false }
  //   );

  //   commit("newTodo", response.data);
  // },
  // async deleteTodo({ commit }, id) {
  //   await axios.delete(`https://jsonplaceholder.typicode.com/todos/${id}`);

  //   commit("removeTodo", id);
  // },
  // async filterTodos({ commit }, e) {
  //   // Get selected number
  //   const limit = parseInt(
  //     e.target.options[e.target.options.selectedIndex].innerText
  //   );

  //   const response = await axios.get(
  //     `https://jsonplaceholder.typicode.com/todos?_limit=${limit}`
  //   );

  //   commit("setTodos", response.data);
  // },
  // async updateTodo({ commit }, updTodo) {
  //   const response = await axios.put(
  //     `https://jsonplaceholder.typicode.com/todos/${updTodo.id}`,
  //     updTodo
  //   );

  //   console.log(response.data);

  //   commit("updateTodo", response.data);
  // }
};

const mutations = {
  setFunctionalAreas: (state, functional_areas) =>
    (state.functional_areas = functional_areas),
  setFunctionalAreasForUser: (state, functional_areas_for_user) =>
    (state.functional_areas_for_user = functional_areas_for_user),
  setFunctionalAreasWithShifts: (state, functional_areas_with_shifts) =>
    (state.functional_areas_with_shifts = functional_areas_with_shifts),
  setRosters: (state, rosters) => (state.rosters = rosters),
  setLaborAgreements: (state, labor_agreements) =>
    (state.labor_agreements = labor_agreements),
  setCostCenters: (state, cost_centers) => (state.cost_centers = cost_centers),
  setDevices: (state, devices) => (state.devices = devices),
  setExcuses: (state, excuses) => (state.excuses = excuses),
  setRoles: (state, roles) => (state.roles = roles),
  // newTodo: (state, todo) => state.todos.unshift(todo),
  // removeTodo: (state, id) =>
  //   (state.todos = state.todos.filter(todo => todo.id !== id)),
  // updateTodo: (state, updTodo) => {
  //   const index = state.todos.findIndex(todo => todo.id === updTodo.id);
  //   if (index !== -1) {
  //     state.todos.splice(index, 1, updTodo);
  //   }
  // }
  setShiftAssignments: (state, shift_assignments) => (state.shift_assignments = shift_assignments),
  setShiftAssignmentsFilters: (state, filters) => (state.shift_assignments_filters = filters),
  setGroups: (state, groups) => (state.groups = groups),
  setGroupsFilters: (state, filters) => (state.groups_filters = filters),
  setHolidays: (state, holidays) => (state.holidays = holidays),
  setHolidaysFilters: (state, filters) => (state.holidays_filters = filters),
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
